/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostLiffWellnessCheckAnswerRequestRespondMessagesInner
 */
export interface PostLiffWellnessCheckAnswerRequestRespondMessagesInner {
    /**
     * 
     * @type {string}
     * @memberof PostLiffWellnessCheckAnswerRequestRespondMessagesInner
     */
    wellnessCheckQuestionId: string;
    /**
     * 
     * @type {string}
     * @memberof PostLiffWellnessCheckAnswerRequestRespondMessagesInner
     */
    respondContent: string;
}

/**
 * Check if a given object implements the PostLiffWellnessCheckAnswerRequestRespondMessagesInner interface.
 */
export function instanceOfPostLiffWellnessCheckAnswerRequestRespondMessagesInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "wellnessCheckQuestionId" in value;
    isInstance = isInstance && "respondContent" in value;

    return isInstance;
}

export function PostLiffWellnessCheckAnswerRequestRespondMessagesInnerFromJSON(json: any): PostLiffWellnessCheckAnswerRequestRespondMessagesInner {
    return PostLiffWellnessCheckAnswerRequestRespondMessagesInnerFromJSONTyped(json, false);
}

export function PostLiffWellnessCheckAnswerRequestRespondMessagesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostLiffWellnessCheckAnswerRequestRespondMessagesInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'wellnessCheckQuestionId': json['wellnessCheckQuestionId'],
        'respondContent': json['respondContent'],
    };
}

export function PostLiffWellnessCheckAnswerRequestRespondMessagesInnerToJSON(value?: PostLiffWellnessCheckAnswerRequestRespondMessagesInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'wellnessCheckQuestionId': value.wellnessCheckQuestionId,
        'respondContent': value.respondContent,
    };
}

